// ============================================
// PAGE - Dev Impersonate (solo uso interno)
// ============================================

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDevImpersonate } from '@almacenes/core';
import { Button, Input } from '@almacenes/ui';
import { useRutFormatter } from '@/hooks/useRutFormatter';

export const DevImpersonatePage = () => {
  const navigate = useNavigate();
  const { mutate: impersonate, isPending, error } = useDevImpersonate();
  const { rawValue: rut, formattedValue: formattedRut, handleChange: handleRutChange, isValid } = useRutFormatter();
  const [masterKey, setMasterKey] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    impersonate(
      { rutAlmacen: rut, masterKey },
      { onSuccess: () => navigate('/dashboard') }
    );
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#F3F4F9' }}>
      <div className="w-full max-w-sm">
        <div className="bg-white rounded-2xl shadow-lg p-8">
          <div className="mb-6">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold bg-orange-100 text-orange-700 mb-4">
              <span>⚠</span> Uso interno — equipo AD
            </div>
            <h1 className="text-title-3">Impersonar almacén</h1>
            <p className="text-sm text-gray-500 mt-1">Ingresa como el propietario de cualquier almacén</p>
          </div>

          {error && (
            <div className="mb-4 rounded-lg bg-red-50 p-3 text-sm text-red-800 border border-red-200">
              {(error as any)?.statusCode === 401
                ? 'Master key incorrecta.'
                : (error as any)?.statusCode === 404
                  ? 'No se encontró un almacén con ese RUT.'
                  : ((error as any)?.message || 'Error al impersonar')}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              label="RUT del almacén"
              type="text"
              required
              value={formattedRut}
              onChange={handleRutChange}
              placeholder="Ej: 76.123.456-7"
            />

            <Input
              label="Master key"
              type="password"
              required
              value={masterKey}
              onChange={(e) => setMasterKey(e.target.value)}
              placeholder="dev-secret-local"
            />

            <Button
              type="submit"
              variant="primary"
              className="w-full py-4"
              size="lg"
              isLoading={isPending}
              disabled={!isValid() || !masterKey}
            >
              Ingresar como propietario
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};
